export const Breakpoints = {
  sm: 560,
  md: 865,
  lg: 960,
  header: 960,
  xl: 1440,
  xxl: 1600,
  '3xl': 2700,
};

const brPx = {};
Object.keys(Breakpoints).map((key) => {
  brPx[key] = `${Breakpoints[key]}px`;
});

export const BreakpointsWithPx = brPx;

